import React, { useCallback, useState, useEffect } from 'react';

import {
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage
} from '@chakra-ui/react';

const TextComponent = ({
  fieldId,
  dataId,
  submitAttempted,
  defaultPlaceholder,
  fieldLabel,
  fieldValue,
  required,
  errorMessage,
  isInvalid,
  onChange = (value) => {},
  onReady = () => {}
}) => {
  const [isError, setIsError] = useState(required);

  const handleOnChange = useCallback(
    (value) => {
      const isInvalidOnChange = required === true && value.length === 0;

      setIsError(isInvalidOnChange);

      onChange({
        fieldId,
        value,
        label: fieldLabel,
        isValid: isInvalidOnChange === false
      });
    },
    [onChange, fieldId, fieldLabel, required]
  );

  useEffect(() => {
    onReady({
      fieldId,
      required
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      mb="3"
      isInvalid={submitAttempted && (isError || isInvalid)}
      isRequired={required}>
      <FormLabel
        id={`field-label-text-${fieldId}-${fieldLabel}`}
        htmlFor={fieldId}
        mb="2">
        {fieldLabel}
      </FormLabel>
      <Input
        id={fieldId}
        data-custom-data-id={dataId}
        name={fieldLabel}
        placeholder={fieldValue || defaultPlaceholder}
        borderRadius="xs"
        background="white"
        borderColor="primary.dark-blue"
        onChange={(event) => handleOnChange(event.target.value)}
        onBlur={(event) => handleOnChange(event.target.value)}
      />
      {submitAttempted && (isError || isInvalid) && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default TextComponent;
